import { render, staticRenderFns } from "./ChooseBeneficiariesReadOnlyView.vue?vue&type=template&id=9b1e6faa&"
import script from "./ChooseBeneficiariesReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ChooseBeneficiariesReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VExpandTransition,VLayout})
